import React from "react";
import Emea from "./Emea";
import FocusArea from "../FocusArea";
const Emeanew = () => {
  return (
    <>
      <div>
        <div>
          <Emea />
        </div>
        <div className="main-container-emea">
          <div className="focusarea">
            <FocusArea />
          </div>
        </div>

        <div className="trainingcompleted"></div>
      </div>
    </>
  );
};

export default Emeanew;
